import { create, StoreApi, UseBoundStore } from 'zustand';

import { SortingState } from '@tanstack/react-table';

import { serializeSort } from './helpers';

export { serializeSort };

// NOTE: this store backs the Inbound Referrals inbox (InboundReferralsListPage) only.
// stores/referralsStore.ts is a separate, legacy Review-typed referrals page — not this one.

export type Tab = 'active' | 'history';

// The chip row's vocabulary (Active tab only). 'actionNeeded' means the per-building queue
// (queue=true — work MY buildings can act on), not the workflow-derived list_status — see
// InboundReferralsListPage's chipParams. The Status dropdown that used to sit beside the chips
// (with its own 'actionNeeded' meaning list_status=action_needed) is gone (OLIO-3172): two
// params behind one label kept returning rows whose pills didn't say "Action Needed".
export type StatusChip = 'all' | 'actionNeeded' | 'readyForReview';

type InboundReferralsActions = {
  setSort: (sort: SortingState) => void;
  setSearch: (search: string) => void;
  setTab: (tab: Tab) => void;
  setStatusChip: (chip: StatusChip) => void;
};

export type InboundReferralsState = {
  sort: SortingState;
  search: string;
  tab: Tab;
  statusChip: StatusChip;
  actions: InboundReferralsActions;
};

const createInboundReferralsStore = (): [
  useStore: UseBoundStore<StoreApi<InboundReferralsState>>,
  useActions: () => InboundReferralsActions,
] => {
  const useStore = create<InboundReferralsState>((set) => ({
    sort: [{ id: 'createdAt', desc: true }],
    search: '',
    tab: 'active',
    statusChip: 'all',
    actions: {
      setSort: (sort) => set({ sort }),
      setSearch: (search) => set({ search }),
      setTab: (tab) => set({ tab }),
      setStatusChip: (statusChip) => set({ statusChip }),
    },
  }));

  const useActions = () => useStore((state) => state.actions);

  return [useStore, useActions];
};

export const [useInboundReferralsStore, useInboundReferralsActions] = createInboundReferralsStore();
